import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { errMsg, useApi } from "@/lib/api";
import { rm } from "@/pages/AkaunPage";

const NAMA = { payg: "Per Use", asas50: "Langganan 50 carian", tanpahad: "Langganan tanpa had" };
const label = (t) => (t.produk === "payg" ? `${t.qty} carian Per Use` : NAMA[t.produk]);

export const UnmatchedSuggestions = ({ item, onDone }) => {
  const api = useApi();
  const [pick, setPick] = useState(null);
  const [busy, setBusy] = useState(false);
  const list = item.cadangan || [];
  const t = item.teka_produk;
  if (!list.length) return <p className="text-xs text-mute" data-testid={`suggest-none-${item.id}`}>Tiada cadangan pengguna. Guna "Aktifkan" untuk pilih secara manual.</p>;
  const go = async () => {
    setBusy(true);
    try { await api("post", `/admin/billing/unmatched/${item.id}/resolve`, { user_id: pick.user_id, ...t }); toast.success(`Kuota diaktifkan untuk ${pick.email}`); setPick(null); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`suggest-${item.id}`}>
      <span className="text-xs text-mute inline-flex items-center gap-1"><Sparkles size={12} className="text-q" /> Cadangan:</span>
      {list.map((u, i) => (
        <button key={u.user_id} disabled={!t} onClick={() => setPick(u)} title={u.sebab.join(" · ")} data-testid={`suggest-pick-${item.id}-${i}`}
          className="group inline-flex items-center gap-2 h-8 pl-3 pr-1 rounded-full border border-line text-xs bg-bg hover:border-[var(--q)] transition-colors disabled:opacity-50">
          <span className="font-medium text-ink">{u.email}</span>
          <span className="text-mute">{u.sebab.slice(0, 2).join(" · ")}</span>
          <span className="h-6 px-2 rounded-full bg-ink text-bg inline-flex items-center font-semibold group-hover:bg-[var(--q)] transition-colors">Aktifkan</span>
        </button>
      ))}
      {!t && <span className="text-xs text-warn">Jumlah tidak sepadan dengan mana-mana produk; guna dialog manual.</span>}
      <AlertDialog open={!!pick} onOpenChange={(o) => !o && !busy && setPick(null)}>
        <AlertDialogContent data-testid="suggest-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Aktifkan untuk {pick?.email}?</AlertDialogTitle>
            <AlertDialogDescription>
              {t && label(t)} akan diaktifkan untuk bayaran OnPay {rm(item.amount_sen || 0)}{item.invois ? ` (invois ${item.invois})` : ""}.
              {pick && <span className="block mt-2 text-xs">Sebab: {pick.sebab.join(" · ")}</span>}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="suggest-confirm-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); go(); }} disabled={busy} data-testid="suggest-confirm-ok">
              {busy && <Loader2 size={14} className="animate-spin mr-2" />} Ya, aktifkan
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
